import React, { useState, useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import { Box } from '@mui/material'
import { RootState } from '../../../reducers'
import { useStyles } from '../Pathologist/inboxStyles'
import { TabPanelProps } from '../../../interfaces/inbox'
import TableComponent from '../Common/TableComponent'
import { UnassignedColumns, AssignedColumns, LMComplete } from './tableColumnHeaders'
import { dropDownUser } from './../../../interfaces/common'
import { LoadBalancer } from './../../HOC/LoadBalancer'
import { getITAdminUnassignedData, getITAdminAssignedData, getITAdminCompleteData } from '../../../actions'
import { getDispatchData, getReadyForPickupData } from '../../../actions'
import ReadyForPickup from '../Logistics/ReadyForPickup'
import DispatchLogistics from '../Logistics/DispatchLogistics'
import { SendSlides } from '../../HOC/SendSlides'
import { ReceiveSlides } from '../../HOC/ReceiveSlides'
function a11yProps(index: unknown) {
  return {
    id: `case-worklist-${index}`,
    'aria-controls': `case-worklist-${index}`,
  }
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`case-worklist-${index}`}
      aria-labelledby={`case-worklist-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0} pt={1}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

export function ITAdmin({ user }): JSX.Element {
  const classes = useStyles()
  const [value, setValue] = useState(0)
  const dispatch = useDispatch()
  const UnassignedData = useSelector((state: RootState) => state.getITAdminUnassignedData)
  const AssignedData = useSelector((state: RootState) => state.getITAdminAssignedData)
  const ITAdminCompleteData = useSelector((state: RootState) => state.getITAdminCompleteData)
  const procedureData = useSelector((state: RootState) => state.getFilterProcedureCodeData)
  const { display_labels } = useSelector((state: RootState) => state.appConfig)
  const [userInfo, setUserInfo] = useState<dropDownUser | null>(null)
  const [filterData, setFilterData] = useState({ data: [] })
  const [tabChanged, setTabChanged] = useState(0)
  const [onTrfSearch, setOnTrfSearch] = useState(false)
  const [loadBalancer, setLoadBalancer] = useState(true)
  const [sendSlides, setSendSlides] = useState(false)
  const [receiveSlides, setReceiveSlides] = useState(false)
  const gridPageSize = 10

  useEffect(() => {
    if (value === 0) {
      dispatch(
        getITAdminUnassignedData({
          id: `${user}`,
          pageIndex: 1,
          pageSize: gridPageSize,
          filterField: 'created_datetime',
          filterValue: null,
          caseView: 'unassigned',
          startDate: null,
          endDate: null,
          sortOrder: 'asc',
          sortField: 'case_number',
        }),
      )
    } else if (value === 1) {
      dispatch(
        getReadyForPickupData({
          id: `${user}`,
          pageIndex: 1,
          pageSize: gridPageSize,
          filterField: 'created_datetime',
          filterValue: null,
          caseView: 'ready_for_pickup',
          startDate: null,
          endDate: null,
          sortOrder: 'asc',
          sortField: 'case_number',
        }),
      )
    } else if (value === 2) {
      dispatch(
        getDispatchData({
          id: `${user}`,
          pageIndex: 1,
          pageSize: gridPageSize,
          filterField: 'created_datetime',
          filterValue: null,
          caseView: 'dispatch',
          startDate: null,
          endDate: null,
          sortOrder: 'asc',
          sortField: 'case_number',
        }),
      )
    } else if (value === 3) {
      dispatch(
        getITAdminAssignedData({
          id: `${user}`,
          pageIndex: 1,
          pageSize: gridPageSize,
          filterField: 'created_datetime',
          filterValue: null,
          caseView: 'assigned',
          startDate: null,
          endDate: null,
          sortOrder: 'asc',
          sortField: 'case_number',
        }),
      )
    } else if (value === 4) {
      dispatch(
        getITAdminCompleteData({
          id: `${user}`,
          pageIndex: 1,
          pageSize: gridPageSize,
          filterField: 'updated_datetime',
          filterValue: null,
          caseView: 'completed',
          startDate: null,
          endDate: null,
          sortOrder: 'desc',
          sortField: 'case_number',
        }),
      )
    }
  }, [dispatch, user, value])

  function handleSendSlides() {
    setLoadBalancer(false)
    setSendSlides(true)
    setReceiveSlides(false)
  }

  function handleReceiveSlides() {
    setLoadBalancer(false)
    setSendSlides(false)
    setReceiveSlides(true)
  }

  function handleNoSlides() {
    setLoadBalancer(false)
    setSendSlides(false)
    setReceiveSlides(false)
  }

  const handleChange = (event, newValue: number) => {
    if (newValue === undefined) return
    setValue(newValue)
    setUserInfo(null)
  }

  function enableLoadBalancer() {
    setLoadBalancer(true)
    setSendSlides(false)
    setReceiveSlides(false)
  }

  function disableLoadBalancer() {
    setLoadBalancer(false)
    setSendSlides(false)
    setReceiveSlides(false)
  }

  const ProcedureCodeRenderer = {
    field: 'procedure_code',
    headerName: 'Case Type',
    sortable: true,
    width: 200,
    headerClassName: 'super-app-theme--header',
    disableClickEventBubbling: true,
    valueGetter: (params) => {
      const procedureCodeResults = procedureData.procedureCodeMap.filter((value) => {
        return value.id == params.row.procedure_code
      })
      return procedureCodeResults[0]?.display
    },
  }

  if (display_labels) {
    AssignedColumns.push(ProcedureCodeRenderer)
    UnassignedColumns.push(ProcedureCodeRenderer)
    LMComplete.push(ProcedureCodeRenderer)
  }

  return (
    <div>
      <Box>
        <AppBar position="static" className={classes.appBar}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="case-worklist"
            classes={{
              indicator: classes.indicator,
            }}
          >
            <Tab label="Unassigned " onClick={enableLoadBalancer} {...a11yProps(1)} style={{ margin: '0px 10px' }} />
            <Tab
              label="Ready for Pickup "
              {...a11yProps(0)}
              onClick={handleReceiveSlides}
              style={{ margin: '0px 10px' }}
            />
            <Tab label="Dispatch" {...a11yProps(1)} onClick={handleSendSlides} style={{ margin: '0px 10px' }} />
            <Tab label="Assigned" onClick={disableLoadBalancer} {...a11yProps(0)} style={{ margin: '0px 10px' }} />
            <Tab label="Completed " onClick={disableLoadBalancer} {...a11yProps(1)} style={{ margin: '0px 10px' }} />
            {onTrfSearch && (
              <Tab label="" {...a11yProps(4)} style={{ margin: '0px', minWidth: '0px', padding: '0px' }} />
            )}
          </Tabs>
          <div className={classes.loadBalancer} style={{ width: '450px' }}>
            {sendSlides && <SendSlides userId={user} setUserInfo={setUserInfo} />}
            {receiveSlides && <ReceiveSlides userId={user} />}
            {loadBalancer && <LoadBalancer user={user} />}
          </div>
        </AppBar>
        {/* {value > 0 && value !== 5 && <UserBanner updateUserView={updateUserView} userInfo={userInfo} />} */}
        <TabPanel value={value} index={0}>
          <TableComponent
            userId={user}
            caseView={'unassigned'}
            isSearchTable={false}
            reducerData={userInfo ? filterData : UnassignedData}
            dispatchData={getITAdminUnassignedData}
            tableColumns={UnassignedColumns}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ReadyForPickup userId={user} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <DispatchLogistics setUserInfo={setUserInfo} userId={user} />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <TableComponent
            userId={user}
            caseView={'assigned'}
            isSearchTable={false}
            reducerData={AssignedData}
            dispatchData={getITAdminAssignedData}
            tableColumns={AssignedColumns}
          />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <TableComponent
            caseView={'completed'}
            userId={user}
            isSearchTable={false}
            reducerData={ITAdminCompleteData}
            dispatchData={getITAdminCompleteData}
            tableColumns={LMComplete}
          />
        </TabPanel>
      </Box>
    </div>
  )
}
